export default {
name:       'oasis-dex',
env:       'production',
buildDate:  new Date(1549304422186),
version:    '1.5.11',
numCommits: 488,
hash:       '1a92e6a',
branch:     'dev',
dirty:      true
}


// WEBPACK FOOTER //
// ./src/version.js